export const CHANGE_CURRENT_SYNC_VIEW = 'CHANGE_CURRENT_SYNC_VIEW'
export const UPDATE_SYNC_PROGRESS = 'UPDATE_SYNC_PROGRESS'
// PG-063 — painel de sincronização
export const SET_SYNC_OPERATION = 'SET_SYNC_OPERATION' // {kind, startedAt} | null
export const SET_SYNC_NOTICE = 'SET_SYNC_NOTICE' // {id, severity, text} | null
export const SET_PULL_SUMMARY = 'SET_PULL_SUMMARY' // {at, farmsCount, durationMs, responseSizeKb}

/**
 * Status de sincronização detalhados
 *
 * 0 = Erro / Sem conexão
 * 1 = Sincronizando (genérico)
 * 2 = Sincronizado com sucesso
 * 3 = Baixando dados da fazenda
 * 4 = Processando registros
 * 5 = Erro - tentando novamente
 */
export const SYNC_STATUS = {
  ERROR: 0,
  SYNCING: 1,
  SUCCESS: 2,
  DOWNLOADING_FARM: 3,
  PROCESSING: 4,
  RETRYING: 5,
}

export const SYNC_STATUS_LABELS = {
  [SYNC_STATUS.ERROR]: 'Sem conexão',
  [SYNC_STATUS.SYNCING]: 'Sincronizando...',
  [SYNC_STATUS.SUCCESS]: 'Sincronizado!',
  [SYNC_STATUS.DOWNLOADING_FARM]: 'Baixando dados da fazenda...',
  [SYNC_STATUS.PROCESSING]: 'Processando registros...',
  [SYNC_STATUS.RETRYING]: 'Erro - tentando novamente...',
}
